/**
 * Public-API key management shapes (brand-session endpoints under
 * `/api/v1/api-keys`). A key authenticates against the separate public API
 * (`lly_live_<prefix>.<secret>`); the brand issues/rotates it from the dashboard.
 */
export type IsoDateTime = string;

/** Scopes an issued key can carry (mirrors backend `ApiScope`). */
export enum ApiScope {
	SEARCH = 'influencers:search',
	READ = 'influencers:read',
	PII = 'influencers:pii',
	REFRESH = 'influencers:refresh'
}

/** Full scope set granted to a self-service dashboard key. */
export const DEFAULT_API_SCOPES: ApiScope[] = [
	ApiScope.READ,
	ApiScope.REFRESH,
	ApiScope.SEARCH,
	ApiScope.PII
];

/** Listing/read shape — never carries the secret (GET /api/v1/api-keys). */
export interface ApiKey {
	id: number;
	name: string;
	prefix: string;
	scopes: string[];
	status: string;
	last_used_at: IsoDateTime | null;
	expires_at: IsoDateTime | null;
	created_at: IsoDateTime;
}

/** Creation/rotation shape — the ONLY time the full `token` is returned. */
export interface ApiKeyCreated {
	id: number;
	name: string;
	prefix: string;
	scopes: string[];
	token: string;
	created_at: IsoDateTime;
	expires_at: IsoDateTime | null;
}

export interface CreateApiKeyRequest {
	name: string;
	scopes: ApiScope[];
}
